<div class="content-manager-container mat-elevation-z4">
  <h2>Content Manager</h2>
  <mat-tab-group>
  <!-- image tab -->
  <mat-tab label="Upload Image" (click)="setUploadType('image')">
      <form [formGroup]="uploadForm">
        <mat-form-field
          class="file-input-field"
          style="display: block; width: 100%"
        >
          <mat-label>Image File</mat-label>
          <input matInput [value]="selectedFile?.name || ''" readonly />
          <mat-hint align="end" class="mat-hint">Max size: 5MB.</mat-hint>
          <button mat-button type="button" (click)="triggerFileInput('image')">
            Choose File
          </button>
          <input
            id="image-upload"
            type="file"
            accept="image/*"
            (change)="onFileChange($event)"
            hidden
          />
        </mat-form-field>
        <div *ngIf="selectedFileError" class="file-error-message" style="color: #d32f2f; margin-bottom: 8px;">
          {{ selectedFileError }}
        </div>
        <button
          mat-raised-button
          color="primary"
          type="button"
          [disabled]="isUploading || !selectedFile"
          style="display: block; width: 100%"
          (click)="uploadType = 'image'; uploadMedia()"
        >
          <ng-container *ngIf="!isUploading; else imageLoadingTpl">
            Upload Image
          </ng-container>
          <ng-template #imageLoadingTpl>
            <span class="upload-spinner">
              <mat-spinner diameter="24" color="accent"></mat-spinner>
            </span>
          </ng-template>
        </button>
      </form>
      <mat-divider></mat-divider>
      <div style="margin-top: 32px"></div>

      <h3>Your Images</h3>
      <div *ngIf="images.length > 0; else noImages" class="gallery-grid">
        <mat-grid-list cols="4" rowHeight="200px" gutterSize="16px">
          <mat-grid-tile *ngFor="let img of images; let i = index">
            <mat-card class="media-card">
              <div style="position: relative; width: 100%; height: 180px">
                <img
                  mat-card-image
                  [src]="img.firebaseUrl"
                  [alt]="img.description"
                  style="object-fit: cover; height: 180px; width: 100%"
                  (load)="onImageLoad(i)"
                  (error)="onImageError(i)"
                  [style.visibility]="imageLoading[i] ? 'hidden' : 'visible'"
                />
                <button
                  mat-icon-button
                  color="warn"
                  class="delete-icon"
                  (click)="confirmDelete('image', img, i)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
                <div *ngIf="imageLoading[i]" class="spinner-overlay">
                  <mat-spinner
                    diameter="40"
                    aria-label="Loading image"
                  ></mat-spinner>
                </div>
              </div>
            </mat-card>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
      <ng-template #noImages>
        <div class="no-content-message">
          Your gallery is empty — let's fix that ✨.
        </div>
      </ng-template>
      <div style="margin-top: 32px"></div>
    </mat-tab>
  <!-- video tab -->
  <mat-tab label="Upload Video" (click)="setUploadType('video')">
      <form [formGroup]="uploadForm">
        <mat-form-field
          class="file-input-field"
          style="display: block; width: 100%"
        >
          <mat-label>Video File</mat-label>
          <input matInput [value]="selectedFile?.name || ''" readonly />
          <mat-hint align="end" class="mat-hint">Max size: 100MB. Max duration: 5 min.</mat-hint>
          <button mat-button type="button" (click)="triggerFileInput('video')">
            Choose File
          </button>
          <input
            id="video-upload"
            type="file"
            accept="video/*"
            (change)="onFileChange($event)"
            hidden
          />
        </mat-form-field>
        <div *ngIf="selectedFileError" class="file-error-message" style="color: #d32f2f; margin-bottom: 8px;">
          {{ selectedFileError }}
        </div>
        <button
          mat-raised-button
          color="accent"
          type="button"
          [disabled]="isUploading || !selectedFile"
          style="display: block; width: 100%"
          (click)="uploadType = 'video'; uploadMedia()"
        >
          <ng-container *ngIf="!isUploading; else videoLoadingTpl">
            Upload Video
          </ng-container>
          <ng-template #videoLoadingTpl>
            <span class="upload-spinner">
              <mat-spinner diameter="24" color="accent"></mat-spinner>
            </span>
          </ng-template>
        </button>
      </form>
      <mat-divider></mat-divider>
      <div style="margin-top: 32px"></div>

      <h3>Your Videos</h3>
      <div *ngIf="videos.length > 0; else noVideos" class="gallery-grid">
        <mat-grid-list cols="4" rowHeight="200px" gutterSize="16px">
          <mat-grid-tile *ngFor="let vid of videos; let i = index">
            <mat-card class="media-card">
              <div style="position: relative; width: 100%; height: 180px">
                <video
                  mat-card-image
                  [src]="vid.firebaseUrl"
                  controls
                  style="object-fit: cover; height: 180px; width: 100%"
                  (loadeddata)="onVideoLoad(i)"
                  (error)="onVideoError(i)"
                  [style.visibility]="videoLoading[i] ? 'hidden' : 'visible'"
                ></video>
                <button
                  mat-icon-button
                  color="warn"
                  class="delete-icon"
                  (click)="confirmDelete('video', vid, i)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
                <div *ngIf="videoLoading[i]" class="spinner-overlay">
                  <mat-spinner
                    diameter="40"
                    aria-label="Loading video"
                  ></mat-spinner>
                </div>
              </div>
            </mat-card>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
      <ng-template #noVideos>
        <div class="no-content-message">
          Lights, camera… well, you know the rest 🎥
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
